import React, { FC } from 'react'
import classNames from 'classnames'

import SEO from 'components/seo'
import ImageScrollButton from 'components/lv1/ImageScrollButton'
import TopicPath from 'components/lv2/topicPath'
import TitleBorder from 'components/lv2/TitleBorder'
import TitleText from 'components/lv2/titleText'
import SpecList from 'components/lv2/SpecList'
import SubpageBgImage from 'components/lv2/subpageBgImage'
import ImageGrid from 'components/lv2/imageGrid'
import SubpageImage from 'components/lv3/subpageImage'

import StylesModule from 'layout/rooms.module.scss'

import MainImg from 'images/rooms/main.jpg'
import BgImg from 'images/rooms/bg.jpg'
import room1Img from 'images/rooms/room1.jpg'
import room2Img from 'images/rooms/room2.jpg'
import room3Img from 'images/rooms/room3.jpg'
import room1_1Img from 'images/rooms/room1-1.jpg'
import room1_2Img from 'images/rooms/room1-2.jpg'
import room1_3Img from 'images/rooms/room1-3.jpg'
import room1_4Img from 'images/rooms/room1-4.jpg'
import room1_5Img from 'images/rooms/room1-5.jpg'
import room2_1Img from 'images/rooms/room2-1.jpg'
import room2_2Img from 'images/rooms/room2-2.jpg'
import room2_3Img from 'images/rooms/room2-3.jpg'
import room3_1Img from 'images/rooms/room3-1.jpg'
import room3_2Img from 'images/rooms/room3-2.jpg'
import room3_3Img from 'images/rooms/room3-3.jpg'

import { MessageProps } from 'message/index.props'
export interface RoomsPageProps {
  message: MessageProps
  lang: string
}

const RoomsPage: FC<RoomsPageProps> = ({ message, lang }) => {
  return (
    <section className={StylesModule.rooms}>
      <SEO title={message.rooms.page_title} lang={lang} />
      <SubpageImage message={message} page="/rooms" src={MainImg} />
      <TopicPath
        top={message.global.topic_path.top}
        name={message.global.topic_path.rooms}
      />
      <SubpageBgImage
        title={message.rooms.title}
        text={message.rooms.text}
        image={BgImg}
      />
      <section className="mt-64 mt-tb-80">
        <TitleBorder title={message.rooms.room_type} addClassName="normal" />
        <div className={classNames(StylesModule.rooms__imageButton, 'mt-50')}>
          <div className={StylesModule.rooms__imageButtonWrap}>
            <ImageScrollButton
              target="room1"
              text={message.rooms.room1.title}
              image={room1Img}
            />
            <ImageScrollButton
              target="room2"
              text={message.rooms.room2.title}
              image={room2Img}
            />
            <ImageScrollButton
              target="room3"
              text={message.rooms.room3.title}
              image={room3Img}
            />
          </div>
        </div>
      </section>
      <section id="room1">
        <div className="mt-64 mt-tb-80">
          <TitleText
            title={message.rooms.room1.title}
            text={message.rooms.room1.text}
          />
        </div>
        <div className="mt-32 mt-tb-40">
          <ImageGrid addClassName="normal">
            <img src={room1_1Img} area-hidden="true" alt="" />
            <img src={room1_2Img} area-hidden="true" alt="" />
            <img src={room1_3Img} area-hidden="true" alt="" />
            <img src={room1_4Img} area-hidden="true" alt="" />
            <img src={room1_5Img} area-hidden="true" alt="" />
          </ImageGrid>
        </div>
        <SpecList
          specName={message.rooms.spec_name}
          specRoom={message.rooms.spec_room1}
        />
      </section>
      <section id="room2">
        <div className="mt-64 mt-tb-80">
          <TitleText
            title={message.rooms.room2.title}
            text={message.rooms.room2.text}
            addClassName="test"
          />
        </div>
        <div className="mt-32 mt-tb-40">
          <ImageGrid addClassName="normal">
            <img src={room2_1Img} area-hidden="true" alt="" />
            <img src={room2_2Img} area-hidden="true" alt="" />
            <img src={room2_3Img} area-hidden="true" alt="" />
          </ImageGrid>
        </div>
        <SpecList
          specName={message.rooms.spec_name}
          specRoom={message.rooms.spec_room2}
        />
      </section>
      <section id="room3">
        <div className="mt-64 mt-tb-80">
          <TitleText
            title={message.rooms.room3.title}
            text={message.rooms.room3.text}
            addClassName="test"
          />
        </div>
        <div className="mt-32 mt-tb-40">
          <ImageGrid addClassName="normal">
            <img src={room3_1Img} area-hidden="true" alt="" />
            <img src={room3_2Img} area-hidden="true" alt="" />
            <img src={room3_3Img} area-hidden="true" alt="" />
          </ImageGrid>
        </div>
        <SpecList
          specName={message.rooms.spec_name}
          specRoom={message.rooms.spec_room3}
        />
      </section>
    </section>
  )
}

export default RoomsPage
